<template>
  <div class="multipleSelectAndInput">
    <el-form
        :model="ruleForm"
        ref="multipleSelectForm"
    >
        <div class="multipleSelectAndInputItem" v-for="(item,index) in ruleForm.items" :key="index">
            <el-form-item 
                :prop="'items.' + index + '.key'"
                :rules="rules"
                :show-message="false"
                style="width: 60%;margin-right: 10px;"
            >
                <el-select 
                    class="multiple_select"
                    placeholder="请选择" 
                    v-model="ruleForm.items[index].key"
                    clearable
                    filterable
                    allow-create
                    @change="(val) => handleChange(val)"
                >
                    <el-option
                        v-for="o in attributeList"
                        :key="o.attributeValueId"
                        :label="o.attributeValue"
                        :value="o.attributeValueId"
                        :disabled="ruleForm.items[index].key != o.attributeValueId && notSelected.includes(o.attributeValueId)"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item 
                :prop="'items.' + index + '.value'"
                :rules="rules"
                :show-message="false"
                style="width: 200px;margin-right: 10px;"
            >
                <el-input 
                    class="multiple_input"
                    placeholder="请输入" 
                    v-model="ruleForm.items[index].value"
                    @blur="handleBlur"
                />
            </el-form-item>
            <el-link :underline="false" style="color:#333;margin-right:10px;" @click="deleteItem(index)" v-if="ruleForm.items.length != 1">删除</el-link>
            <el-link :underline="false" @click="add">添加</el-link>
        </div>
    </el-form>
  </div>
</template>
<script>
// import { requiredValidate } from './rulesValidate.js'
export default {
  props: {
    value:{
        type:Array,
        default: () => {
            return [];
        }
    },
    formdata:  {
      type: Object,
      default: () => {
        return {};
      }
    },
    attributeList:  {
      type: Array,
      default() {
        return [];
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
        ruleForm:{
            items: [
                { key: '', value: '' }
            ]
        },
        rules:{required:true,message:'', trigger: ['change','blur']},
        // rules:{required:true,validator:requiredValidate(), trigger: ['change','blur']},
    };
  },
  watch: {
    value:{
        handler(v){
            if(v && v.length > 0){
              this.ruleForm.items = v
            }
        },
        deep: true,
        immediate: true
    }
  },
  computed: {
    // 禁止选的属性
    notSelected(){
        let list = this.ruleForm.items.filter(item => item.key).map(item => item.key)
        return list
    }
  },

  methods: {
    add(){
        this.ruleForm.items.push({ key: '', value: '' });
    },
    deleteItem(index){
        this.ruleForm.items.splice(index, 1);
    },
    handleChange(val){
        this.$emit('change', this.ruleForm.items);
        this.$emit('selectChange', val);
        this.$emit('valid');
    },
    handleBlur(){
        this.$emit('change', this.ruleForm.items);
        this.$emit('valid')
    }
  },
  mounted(){
  }
};
</script>

<style lang="scss" scope>
.multipleSelectAndInput{
    width: 100%;
    .multipleSelectAndInputItem{
        display: flex;
        width: 100%;
    }
    .multipleSelectAndInputItem + .multipleSelectAndInputItem{
        margin-top: 10px;
    }
    .multiple_select{
        width: 100%;
        margin-right: 10px;
    }
    .multiple_input{
        width: 100%;
        margin-right: 10px;
    }
}
</style>